import { render } from "./SubjectDeleteDialog.vue?vue&type=template&id=28ae228e"
import script from "./SubjectDeleteDialog.vue?vue&type=script&lang=js"
export * from "./SubjectDeleteDialog.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__